import React from 'react';
import { Link } from 'react-router-dom';

const CoreValueSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-white via-slate-50/90 to-cyan-50/30 py-20 md:py-28">
      <div className="pointer-events-none absolute -right-24 top-0 h-72 w-72 rounded-full bg-cyan-400/12 blur-3xl" />
      <div className="pointer-events-none absolute -left-16 bottom-0 h-48 w-48 rounded-full bg-primary/10 blur-2xl" />
      <div className="relative mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold tracking-tight text-slate-900 md:text-4xl lg:text-5xl lg:leading-[1.12]">
          Run your business{' '}
          <span className="bg-gradient-to-r from-primary to-cyan-600 bg-clip-text text-transparent">
            from one organized dashboard
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg text-slate-600 md:text-xl">
          Professional quote builder, clients, projects, expenses, files, and invoices in one contractor management workspace.
        </p>
        <div className="mx-auto mt-12 grid max-w-3xl gap-4 text-left sm:grid-cols-3 sm:gap-6">
          {[
            { k: 'Professional', v: 'Branded quotes and invoices clients trust.' },
            { k: 'Organized', v: 'Clients, projects, costs, and files together.' },
            { k: 'Practical', v: 'Built for contractors in Canada and the U.S.' },
          ].map((row) => (
            <div
              key={row.k}
              className="rounded-2xl border border-slate-200/90 bg-white px-4 py-5 shadow-sm"
            >
              <p className="text-xs font-bold uppercase tracking-wide text-cyan-800">{row.k}</p>
              <p className="mt-2 text-sm leading-snug text-slate-600">{row.v}</p>
            </div>
          ))}
        </div>
        <div className="mt-14 flex w-full flex-col items-stretch gap-4 px-4 sm:flex-row sm:items-center sm:justify-center sm:px-0">
          <Link to="/account" className="block sm:inline-block">
            <button
              type="button"
              className="btn-primary w-full rounded-2xl px-8 py-3.5 text-base font-bold text-white shadow-lg sm:w-auto"
            >
              Start Building Invoices
            </button>
          </Link>
          <Link to="/plans" className="block sm:inline-block">
            <button
              type="button"
              className="w-full rounded-2xl border-2 border-slate-200 bg-white px-8 py-3.5 text-base font-semibold text-slate-800 shadow-sm transition hover:border-slate-300 sm:w-auto"
            >
              View pricing
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CoreValueSection;
